/**
 * @generated SignedSource<<3b1a118830ac0eedb87ad32dc4e5d4d2>>
 * @relayHash 7d6a869c09204c7d84df37a258b0d6e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e14d2944f18618b4c9f328ada306fe21bbcaf96329e6d76bbd49770979a9e5ed

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectPanelQuery$variables = {
  ari: string;
};
export type ProjectPanelQuery$data = {
  readonly townsquare: {
    readonly project: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ProjectLinks" | "ProjectOwner" | "ProjectPanelHeader" | "ProjectStatus" | "ProjectTags" | "ProjectTargetDate">;
    } | null | undefined;
  } | null | undefined;
};
export type ProjectPanelQuery = {
  response: ProjectPanelQuery$data;
  variables: ProjectPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ari",
    "variableName": "ari"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectPanelQuery",
    "selections": [
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TownsquareProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "ProjectPanelHeader"
              },
              {
                "kind": "FragmentSpread",
                "name": "ProjectTags"
              },
              {
                "kind": "FragmentSpread",
                "name": "ProjectTargetDate"
              },
              {
                "kind": "FragmentSpread",
                "name": "ProjectStatus"
              },
              {
                "kind": "FragmentSpread",
                "name": "ProjectOwner"
              },
              {
                "kind": "FragmentSpread",
                "name": "ProjectLinks"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectPanelQuery",
    "selections": [
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TownsquareProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "TownsquareIconURIs",
                "kind": "LinkedField",
                "name": "iconUrl",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareThemeURIs",
                    "kind": "LinkedField",
                    "name": "roundedSquare",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "dark"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "light"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareTagConnection",
                "kind": "LinkedField",
                "name": "tags",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareTagEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareTag",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareTargetDate",
                "kind": "LinkedField",
                "name": "dueDate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareTargetDateRange",
                    "kind": "LinkedField",
                    "name": "dateRange",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "start"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "end"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareProjectState",
                "kind": "LinkedField",
                "name": "state",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "label"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "picture"
                  }
                ]
              },
              {
                "concreteType": "TownsquareLinkConnection",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareLinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareLink",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "url"
                          },
                          (v3/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e14d2944f18618b4c9f328ada306fe21bbcaf96329e6d76bbd49770979a9e5ed",
    "metadata": {},
    "name": "ProjectPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3a28640ca8a81db534ca32755500b335";

export default node;
